import React, { useEffect, useState } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { resetProjectSubprojects } from '#action/list-filter/index';
import { SubComponentContainer, Label } from '#component/general/list-filter/components/general/styles';

export const SubprojectRadioButtonsGroup = ({
  name,
  label,
  relatedTo,
  options,
  onChange
}) => {
  const dispatch = useDispatch();
  const selected = useSelector(s => s.listFilter?.[relatedTo]?.[name]?.value, shallowEqual) ?? {};
  const search = useSelector(s => s.listFilter?.[relatedTo]?.search?.value, shallowEqual) ?? '';
  const device = useSelector(s => s.listFilter?.[relatedTo]?.device?.value, shallowEqual) ?? [];
  const user = useSelector(s => s.listFilter?.[relatedTo]?.user?.value, shallowEqual) ?? [];
  const defaultValue = options.find(o => o.data.default)?.data?.value ?? options?.[0]?.data?.value;
  const val = selected?.[0]?.data?.value || defaultValue;
  const [value, setValue] = useState(val);
  const disabled = device.length || user.length || !search.length;

  useEffect(() => {
    if (val !== value) {
      setValue(val);
    }
  }, [val, value]);

  useEffect(() => {
    if ((device.length || user.length || !search.length) && value !== defaultValue) {
      dispatch(resetProjectSubprojects());
    }
  }, [device.length, user.length, search.length, defaultValue, value, dispatch]);

  const handleChange = (e, newValue) => {
    setValue(newValue);
    onChange(options.filter(o => o.data.value === newValue));
  };

  return (
    <SubComponentContainer>
      <Label>{label}</Label>
      <RadioGroup
        row
        name={name}
        value={value}
        onChange={handleChange}
        id={`filter-radio-button-group-${label}`}
      >
        {options.map(option => {
          const { label: l, data: d } = option;
          const v = d.value;
          return <FormControlLabel key={`${l}_${v}`} value={v} control={<Radio />} label={l} disabled={disabled} />;
        })}
      </RadioGroup>
    </SubComponentContainer>
  );
};
